import React from 'react';
import { FadeInSection } from '../ui/FadeInSection';
import { Shield, Brain, Heart } from 'lucide-react';
export function CredibilitySection() {
  return <section className="py-16 md:py-20 bg-white px-4" data-id="element-51">
      <div className="max-w-3xl mx-auto text-center" data-id="element-52">
        <FadeInSection data-id="element-53">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-10" data-id="element-54">
            Un Enfoque Basado en la Ciencia, Diseñado para la Vida Real
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-gray-800 leading-relaxed mb-12 text-left" data-id="element-55">
            <p data-id="element-56">
              Este no es otro libro de dietas de moda inventado de la noche a la
              mañana.
            </p>
            <p data-id="element-57">
              "El Código del Azúcar en Sangre" está basado en principios sólidos
              de nutrición moderna y comportamiento alimentario.
            </p>
            <p data-id="element-58">
              Se fundamenta en cómo tu cuerpo procesa biológicamente los
              alimentos y cómo responde a la insulina.
            </p>
            <p data-id="element-59">
              Ha sido diseñado específicamente para la vida real, para personas
              ocupadas que trabajan, tienen familia y no tienen tiempo para
              complicaciones.
            </p>
            <p data-id="element-60">
              Es un enfoque práctico, lógico y 100% aplicable desde tu próxima
              comida.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-61">
            <div className="p-6 bg-gray-50 rounded-xl flex flex-col items-center" data-id="element-62">
              <Shield className="w-12 h-12 text-green-600 mb-4" data-id="element-63" />
              <h4 className="font-bold text-gray-900" data-id="element-64">Método Seguro</h4>
              <p className="text-sm text-gray-600 mt-2" data-id="element-65">
                Sin extremos ni restricciones peligrosas.
              </p>
            </div>
            <div className="p-6 bg-gray-50 rounded-xl flex flex-col items-center" data-id="element-66">
              <Brain className="font-bold w-12 h-12 text-green-600 mb-4" data-id="element-67" />
              <h4 className="font-bold text-gray-900" data-id="element-68">Lógica Biológica</h4>
              <p className="text-sm text-gray-600 mt-2" data-id="element-69">
                Trabaja a favor de tu cuerpo, no en su contra.
              </p>
            </div>
            <div className="p-6 bg-gray-50 rounded-xl flex flex-col items-center" data-id="element-70">
              <Heart className="w-12 h-12 text-green-600 mb-4" data-id="element-71" />
              <h4 className="font-bold text-gray-900" data-id="element-72">Sostenible</h4>
              <p className="text-sm text-gray-600 mt-2" data-id="element-73">
                Diseñado para mantenerlo toda la vida.
              </p>
            </div>
          </div>
        </FadeInSection>
      </div>
    </section>;
}